module.exports = __webpack_public_path__ + "img/flower_leaf_30.014653cd.png";